import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './WheelProposalCard.scss';

const WheelProposalCard = ({ hero, onYes, onNo }) => {
  const [term, setTerm] = useState(hero.term || '');

  return (
    <div className='wheel-proposal-card'>
      <input className='wheel-proposal-term' value={term} onChange={event => setTerm(event.target.value)} aria-label='Proposed term' maxLength={80} />
      <div className='wheel-proposal-actions'>
        <button type='button' className='wheel-proposal-yes' onClick={() => term.trim() && onYes(term.trim())} disabled={!term.trim()}>
          Yes
        </button>
        <button type='button' className='wheel-proposal-no' onClick={onNo}>
          No
        </button>
      </div>
    </div>
  );
};

WheelProposalCard.propTypes = {
  hero: PropTypes.object.isRequired,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired
};

export default WheelProposalCard;
